import { render, staticRenderFns } from "./QuestionReport.AgreeAnalysis.ComparisonButton.vue?vue&type=template&id=463f0b2e&"
import script from "./QuestionReport.AgreeAnalysis.ComparisonButton.vue?vue&type=script&lang=js&"
export * from "./QuestionReport.AgreeAnalysis.ComparisonButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports